<app-searchable-dropdown
  [options]="options()"
  [value]="selectedValue()"
  [placeholder]="placeholder()"
  [panelHorizontalAlign]="panelHorizontalAlign()"
  [triggerAppearance]="triggerAppearance()"
  mode="single"
  (selectionChange)="onSelectionChange($event)"
/>
